import { Empty } from 'src/pages/main/inbox/pages/Empty/Empty'

export const Root = () => {
  return <Empty />
}
